export { default } from './CarouselTags';
